const State = {
  selectedLanguage: undefined,
};
export default State;
